import React, { useCallback } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Layout from '../components/layout';
import UsAboutUsContainer from '../structure/us/about_us';
import PlAboutUsContainer from '../structure/pl/about_us';
import NgAboutUsContainer from '../structure/ng/about_us';
import CzAboutUsContainer from '../structure/cz/about_us';
import { useAboutUsHeroImage } from '../hooks/useAboutUsHeroImage';

const CountryBasedComponent = function ({ country }) {
  switch (country) {
    case 'us':
      return <UsAboutUsContainer />;
    case 'ng':
      return <NgAboutUsContainer />;
    case 'pl':
      return <PlAboutUsContainer />;
    case 'cz':
      return <CzAboutUsContainer />;
    default:
      return <UsAboutUsContainer />;
  }
};

CountryBasedComponent.propTypes = {
  country: PropTypes.string,
};

CountryBasedComponent.defaultProps = {
  country: undefined,
};

const AboutUs = function ({ location, pageContext }) {
  const { country, language } = pageContext;
  const { imageFileName, imagePosition, imageTitle, imageAlt } =
    useAboutUsHeroImage(country);
  const BasedComponent = useCallback(
    () => <CountryBasedComponent country={country} />,
    [country],
  );
  return (
    <Layout
      pageTitle="web.navigation.about.us"
      description="seo.description.about"
      title="seo.title.about"
      keywords="seo.keywords.about"
      imageFileName={imageFileName}
      imageTitle={imageTitle}
      imageAlt={imageAlt}
      primaryText="web.header.about.primary"
      secondaryText="web.header.about.secondary"
      location={location}
      country={country}
      language={language}
      imagePosition={imagePosition}
    >
      <BasedComponent />
    </Layout>
  );
};

AboutUs.propTypes = {
  location: PropTypes.shape({}).isRequired,
  pageContext: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
  }),
};

AboutUs.defaultProps = {
  pageContext: {
    country: undefined,
    language: undefined,
  },
};

export default AboutUs;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
